import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { lastValueFrom } from "rxjs";
import { ConfigurationBackend } from "src/app/backend/api/configuration.backend";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";

@Injectable()
export class ProvideConfigurationGuard {
  private readonly bootstrapService = inject(BootstrapService);
  private readonly configurationBackend = inject(ConfigurationBackend);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      const configuration = await lastValueFrom(
        this.configurationBackend.load()
      );

      this.bootstrapService.setCurrentConfiguration(configuration);

      return true;
    } catch (ex) {
      if (this.bootstrapService.getCurrentProduct() === "Rocket") {
        return false;
      }

      return true;
    }
  }
}
